/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Cat_ConstructedInputs */



/**
* | output |
* | --- |
* | "Constructed" |
*
* @param {Rankings_Cat_ConstructedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_cat_constructed = /** @type {((inputs?: Rankings_Cat_ConstructedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Cat_ConstructedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Construit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Constructed")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Constructed")
	if (locale === "it") return /** @type {LocalizedString} */ ("Constructed")
	return /** @type {LocalizedString} */ ("Constructed")
});